import BigNumber from 'bignumber.js'
import lotteryABI from 'config/abi/lottery.json'
import dmdABI from 'config/abi/dmd.json'
import { multicallWithAbi } from 'utils/multicall'
import { getDmdAddress, getLotteryAddress } from 'utils/addressHelpers'
import { DEAD_ADDRESS } from 'config'

const fetchWheelPublicData = async () => {
  const calls = [
    {
      address: getLotteryAddress(),
      name: 'maxBuyTicket',
      abi: lotteryABI,
    },
    {
      address: getLotteryAddress(),
      name: 'bribeFee',
      abi: lotteryABI,
    },
    {
      address: getLotteryAddress(),
      name: 'endTime',
      abi: lotteryABI,
    },
    {
      address: getLotteryAddress(),
      name: 'isOpened',
      abi: lotteryABI,
    },
    {
      address: getLotteryAddress(),
      name: 'DMDPerTicket',
      abi: lotteryABI,
    },
    {
      address: getLotteryAddress(),
      name: 'lastWinners',
      abi: lotteryABI,
    },
    {
      address: getDmdAddress(),
      name: 'balanceOf',
      params: [DEAD_ADDRESS],
      abi: dmdABI,
    },
    {
      address: getLotteryAddress(),
      name: 'randomNumber',
      abi: lotteryABI,
    },
    {
      address: getLotteryAddress(),
      name: 'prizePoolBalance',
      abi: lotteryABI,
    },
  ]
  const [
    maxBuyTicketFC,
    bribeFeeFC,
    endTimeFC,
    isOpenedFC,
    ticketPriceFC,
    lastWinnersFC,
    totalBurnedFC,
    randomNumberFC,
    prizePoolBalanceFC,
  ] = await multicallWithAbi(calls)

  return {
    maxBuyTicket: new BigNumber(maxBuyTicketFC[0]._hex).toNumber(),
    bribeFee: new BigNumber(bribeFeeFC[0]._hex),
    endTime: new BigNumber(endTimeFC[0]._hex).toNumber(),
    isOpened: isOpenedFC[0],
    ticketPrice: new BigNumber(ticketPriceFC[0]._hex),
    lastWinners: lastWinnersFC[0],
    totalBurned: new BigNumber(totalBurnedFC[0]._hex),
    randomNumber: (new BigNumber(randomNumberFC[0]._hex).toNumber() % 1000) + 1,
    prizePoolBalance: new BigNumber(prizePoolBalanceFC[0]._hex),
  }
}

export default fetchWheelPublicData
